<template>
  <el-popover placement="bottom-start" trigger="click" class="m-l-10 m-r-10" :visible-arrow="false">
    <div class="class-drafts-content">
      <table class="native-table">
        <tr>
          <th>班级</th>
          <th>时间</th>
          <th class="action">操作</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.class_obj.name }}</td>
          <td>{{ item.create_time }}</td>
          <td>
            <el-button type="text" size="small" @click.native="submit(item)">开班</el-button>
            <el-button type="text" size="small" class="el-button--danger" @click.native="del(item)">删除</el-button>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="3">暂无数据</td>
        </tr>
      </table>
    </div>
    <el-button slot="reference" :size="size || 'medium'">
      草稿箱
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
  </el-popover>
</template>
<script>
import { Popover } from 'element-ui';
import { classApi } from '@/api';

export default {
  name: 'Drafts',
  components: {
    ElPopover: Popover
  },
  props: {
    size: {
      type: String
    }
  },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      classApi.classDrafts({}).then(res => {
        if (res) this.list = res.data.list;
      });
    },
    submit(item) {
      this.$emit('create', item.class_obj);
    },
    del(item) {
      classApi.controlClassDrafts({ id: item.id, methold: 'DELETE' }).then(res => {
        if (res) {
          this.$message.success(res.msg || '删除成功！');
          this.search();
        }
      });
    }
  }
};
</script>
<style lang="less">
.class-drafts-content {
  max-height: 50vh;
  overflow: auto;
  .action {
    width: 80px;
  }
  .el-button--danger {
    color: #f56c6c;
  }
  td {
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
